import api from "../../utils/MyApi";


export async function login(payload) {
  try {
    return await api.post(`v1/vendor/login`, payload)
  }
  catch (e) {
    return e.response
  }

}
export async function loginGoogle(payload) {
  try {
    return await api.post(`v1/vendor/login/google`, payload)
  }
  catch (e) {
    return e.response
  }

}
export async function loginGoogleUrl() {
  try {
    return await api.get(`v1/vendor/google`)
  }
  catch (e) {
    return e.response
  }

}

export async function forget(payload) {
  try {
    return await api.post(`v1/vendor/forget`, payload)
  }
  catch (e) {
    return e.response
  }

}

export async function logout() {
  return await api.post(`auth/logout`)
}

export async function getProfile() {
  return await api.get('auth/me')
}

export async function loginImpersonate(token) {
  try {
    return await api.get(`v1/vendor/impersonate/${token}`)
  }
  catch (e) {
    return e.response
  }

}



